import { render } from "./PriceModel.vue?vue&type=template&id=5812b4a5&scoped=true"
import script from "./PriceModel.vue?vue&type=script&lang=js"
export * from "./PriceModel.vue?vue&type=script&lang=js"

import "./PriceModel.vue?vue&type=style&index=0&id=5812b4a5&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5812b4a5"]])

export default __exports__